module.exports = __webpack_public_path__ + "static/media/grid-menu-icon.5564a270.svg";